var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlammable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce6e",
    d: "M31.5 0A31.5 31.5 0 1 0 63 31.5 31.5 31.5 0 0 0 31.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff462e",
    d: "M129.062 105.765c13.743-4.612 14.59-16.661 9.6-26.544-2.636-4.612-.847-7.436-.847-7.436s-5.271.941-7.436 5.177c-3.012-6.495 4.518-9.13-.565-20.238 0 0-2.259 4.048-8.66 7.436s-5.93 10.919-5.93 10.919a8.4 8.4 0 0 0-7.06-5.93 13.536 13.536 0 0 1-1.694 9.413c-2.824 4.33-9.978 23.814 15.061 27.2 0 0-11.578-8.095-6.307-21.932 0 0 1.412 3.295 3.765 4.236a11.383 11.383 0 0 1 6.965-7.907s-.565 6.589 2.353 9.036c0 0 3.012-1.788 3.389-4.518.004.003 4.614 12.334-2.634 21.088z",
    transform: "translate(-90.614 -49.744)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlammable);
export default __webpack_public_path__ + "static/media/flammable.b6b454ea810d973e6957bf5a76cbc3b0.svg";
export { ForwardRef as ReactComponent };